var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',[_c('title-component',{attrs:{"slot":"title","type":"h2","title":_vm.$t('landingPages.create.title')},slot:"title"}),_c('landing-page-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }